import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { Response, PaginateResponse } from 'app/model';
import { WellSchematicApplication } from '../model';
import { WellSchematicDiagramState } from '../state/well-schematic-diagram.state';

@Injectable({ providedIn: 'root' })
export class WellSchematicApplicationService {
    constructor(
        private _httpClient: HttpClient,
        private state: WellSchematicDiagramState
    ) { }

    downloadExcel() {
        const url = composeUrl(
            `/v1/Wellbarrier/DownloadWellSchematicApplicationList`
        );
        this._httpClient
            .get(url, { responseType: 'blob' })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `well-schematic.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    }

    getWellApplicationList(
        params: any
    ): Observable<Response<PaginateResponse<any>>> {
        const url = composeUrl(
            `/v1/Wellbarrier/wellSchematicApplicationList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<any>>>(url)
            .pipe(
                take(1),
                this.state.resolveStore((response) => {
                    return { applications: response.data.data };
                })
            );
    }

    updateWellApplicationList(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/wellSchematicApplication`);
        return this._httpClient.put<Response<any>>(url, payload).pipe(take(1));
    }

    getWellSchematicDashboard(
        params: any
    ): Observable<Response<PaginateResponse<any>>> {
        const url = composeUrl(`/v1/WBS/DashboardWbs/overview/well-barrier-diagram`, params);
        return this._httpClient
            .get<Response<PaginateResponse<any>>>(url)
            .pipe(take(1),);
    }

    getAttachmentImageUrl(id: string): Observable<string> {
        const url = composeUrl(
            `v1/WBS/DashboardWbs/well-schematic-attachment`, { id }
        );
        return this._httpClient.get(url, {
            responseType: 'blob'
        }).pipe(
            // transform blob into a usable URL string
            map((blob: Blob) => {
                if (!blob.type.includes('png')) {
                    return null
                }
                return URL.createObjectURL(blob);
            })
        );
    }

    getMonitoringHistory(params: any): Observable<Response<PaginateResponse<any>>> {
        const url = composeUrl(
            `v1/Wellbarrier/monitoringHistory`, params
        );
        return this._httpClient
            .get<Response<PaginateResponse<any>>>(url)
            .pipe(take(1),);
    }
}
